import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SearchComponent } from '../search/search.component';
import { CarouselsService } from 'src/app/services/carousels.service';
import { FileStorageService } from 'src/app/services/file-storage.service';

@Component({
    selector: 'app-carousel',
    templateUrl: './carousel.component.html',
    styles: [],
    standalone: true,
    imports: [ CommonModule, SearchComponent], 
})
export class CarouselComponent implements OnInit {

  @Input()
  typeSearch: string = 'Employee';

  carouselItems: any[] = [];
  loading: boolean = true;

  constructor(
    private carouselsService: CarouselsService,
    private fileStorage: FileStorageService
  ) { }

  ngOnInit(): void {
    this.loadCarouselItems();
  }
  
  // Método para inicializar el carrusel una vez que los datos estén cargados
  initCarousel(): void {
    // Asegurarnos que el DOM está actualizado antes de inicializar el carrusel
    setTimeout(() => {
      const myCarouselElement = document.querySelector('#carouselRedLaboral');
      if (myCarouselElement) {
        try {
          const carouselRedLaboral: any = new (window as any).bootstrap.Carousel(myCarouselElement, {
            interval: 5000,
            wrap: true,
            keyboard: true,
            touch: true,
            cycle: true
          });
          console.log('Carrusel inicializado correctamente con ' + this.carouselItems.length + ' elementos');
        } catch (error) {
          console.error('Error al inicializar el carrusel:', error);
        }
      } else {
        console.error('Elemento del carrusel no encontrado');
      }
    }, 100);
  }

  loadCarouselItems(): void {
    this.carouselsService.getCarousels().subscribe({
      next: (carousels: any[]) => {
        // Get current date for comparison
        const currentDate = new Date();
        
        // Filter carousels that are enabled and within valid date range
        this.carouselItems = carousels
          .filter(carousel => {
            // Check if carousel is enabled
            if (!carousel.isEnabled) return false;
            
            // Check date range
            const startDate = carousel.startDate ? new Date(carousel.startDate) : null;
            const endDate = carousel.endDate ? new Date(carousel.endDate) : null;
            
            return (!startDate || currentDate >= startDate) && (!endDate || currentDate <= endDate);
          })
          .map(carousel => {
            return {
              ...carousel,
              imageUrl: carousel.fileId ? this.fileStorage.getFileUrl(carousel.fileId) : null
            };
          });
          
        this.loading = false;
        
        // If no active carousels found, load default images
        if (this.carouselItems.length === 0) {
          this.loadDefaultImages();
        }
        
        // Inicializar carrusel después de que los datos estén cargados
        setTimeout(() => {
          this.initCarousel();
        }, 300);
      },
      error: (error) => {
        console.error('Error loading carousel items:', error);
        this.loading = false;
        this.loadDefaultImages();
        
        // También intentar inicializar el carrusel en caso de error
        setTimeout(() => {
          this.initCarousel();
        }, 300);
      }
    });
  }
  
  loadDefaultImages(): void {
    // Add default images if no dynamic images are available
    this.carouselItems = [
      { imageUrl: 'assets/Images/carrousel/slide-01.jpg' },
      { imageUrl: 'assets/Images/carrousel/slide-02.jpg' },
      { imageUrl: 'assets/Images/carrousel/slide-03.jpg' }
    ];
  }

}
